import React from 'react';
import {
  Box, Typography, TextField, Checkbox, FormControlLabel
} from '@mui/material';
import { Schedule } from '@mui/icons-material';

const OperatingHoursStep = ({ formik, textFieldStyles }) => {
  return (
    <Box>
      <Typography
        variant='h5'
        gutterBottom
        sx={{ color: '#1976d2', textAlign: 'center', mb: 3, fontWeight: 'bold' }}
      >
        <Schedule sx={{ verticalAlign: 'middle', mr: 1 }} />
        Operating Hours
      </Typography>

      <Typography variant='h6'>Select Days Open</Typography>
      {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map((day) => (
        <FormControlLabel
          key={day}
          control={
            <Checkbox
              sx={{ color: '#3A6E9E' }}
              checked={formik.values.operating_hours?.days_open?.includes(day) || false}
              onChange={(e) => {
                const selectedDays = formik.values.operating_hours?.days_open || [];
                if (e.target.checked) {
                  formik.setFieldValue('operating_hours.days_open', [...selectedDays, day]);
                } else {
                  formik.setFieldValue(
                    'operating_hours.days_open',
                    selectedDays.filter((d) => d !== day)
                  );
                }
              }}
            />
          }
          label={day}
        />
      ))}

      {/* Weekday Operating Hours */}
      <Typography variant='h6'>Weekday Hours (Monday - Friday)</Typography>
      <TextField
        name='operating_hours.weekdays.start_time'
        label='Opening Time'
        type='time'
        fullWidth
        required
        InputLabelProps={{ shrink: true }}
        onChange={formik.handleChange}
        value={formik.values.operating_hours?.weekdays?.start_time || ''}
        sx={textFieldStyles}
      />

      <TextField
        name='operating_hours.weekdays.end_time'
        label='Closing Time'
        type='time'
        fullWidth
        required
        InputLabelProps={{ shrink: true }}
        onChange={formik.handleChange}
        value={formik.values.operating_hours?.weekdays?.end_time || ''}
        sx={textFieldStyles}
      />

      {/* Weekend Operating Hours */}
      <Typography variant='h6'>Weekend Hours (Saturday & Sunday)</Typography>
      <TextField
        name='operating_hours.weekends.start_time'
        label='Opening Time'
        type='time'
        fullWidth
        required
        InputLabelProps={{ shrink: true }}
        onChange={formik.handleChange}
        value={formik.values.operating_hours?.weekends?.start_time || ''}
        sx={textFieldStyles}
      />

      <TextField
        name='operating_hours.weekends.end_time'
        label='Closing Time'
        type='time'
        fullWidth
        required
        InputLabelProps={{ shrink: true }}
        onChange={formik.handleChange}
        value={formik.values.operating_hours?.weekends?.end_time || ''}
        sx={textFieldStyles}
      />
    </Box>
  );
};

export default OperatingHoursStep;
